module.exports = __webpack_public_path__ + "img/schiller-defigard-touch-7.de27baf7.png";